


















import { Component, Vue, Watch } from 'vue-property-decorator'
import util from '../../common/util'

@Component({})
export default class Ver extends Vue {
  code = ''

  @Watch('code')
  handleCodeChange(val: string) {
    this.code = val.replace(/[^\w]/g, '')
  }

  checkCode(code: string) {
    if (util.regexpMap.regexp_coupon_type.test(code)) { // 优惠券
      this.$router.push({ path: 'cou_detail/' + code })
    } else if (util.regexpMap.regexp_gift_type.test(code)) { // 礼品卡
      this.$router.push({ path: 'gift_detail/' + code })
    } else {
      this.showToast('请输入正确的券码')
    }
  }

  onScan() {
    // @ts-ignore
    this.$wechat.promise.then(wx => {
      // @ts-ignore
      wx.scanQRCode((res) => {
        this.checkCode(String(res.resultStr))
      })
      // @ts-ignore
    }, wx => {
      window.console.log('微信JSSDK校验错误:', JSON.stringify(wx.res))
    })
  }

  onQuery() {
    let code = this.code.trim().toUpperCase()
    if (!code) {
      this.showToast('请输入券码')
      return false
    }
    this.$store.dispatch('UPDATE_CONSULTANT', {})
    this.$store.dispatch('UPDATE_COUPON_CODE', '')
    this.checkCode(code)
  }
}
